module.exports = __webpack_public_path__ + "static/media/Мальцева С., Деревцов Е. (ММ).af2670f6.pdf";